import React from 'react';

import TextCell from 'app/components/data-table/TextCell';
import TimestampCell from 'app/components/data-table/TimestampCell';

import IntegrationAvatarCell from 'app/components/data-table/IntegrationAvatarCell';
import PipelineCell from './cells/PipelineCell';
import StatusCell from './cells/status-cell';
import StatusReasonCell from './cells/StatusReasonCell';
import ActionsCell from './cells/ActionsCell';

const eventDebuggerTableColumns = [
  {
    name: 'Integration',
    cell: row => (
      <IntegrationAvatarCell starterkitId={row.starterkitId} name={row.name} AvatarProps={{ size: 'small' }} />
    ),
    width: '290px',
  },
  {
    name: 'Pipeline',
    selector: row => <PipelineCell writekey={row.writeKey} />,
    minWidth: '180px',
    wrap: true,
  },
  {
    name: 'Status',
    cell: row => <StatusCell status={row.status} />,
    width: '120px',
  },
  {
    name: 'Status Reason',
    cell: row => <StatusReasonCell statusReason={row.statusReason} />,
    width: '150px',
  },
  {
    name: 'Event Name',
    selector: row => <TextCell mono text={row.normalizedEventName} />,
    width: '200px',
  },
  {
    name: 'Timestamp',
    selector: row => <TimestampCell timestamp={row.timestamp} />,
    allowOverflow: true,
    width: '180px',
  },
  {
    name: 'Actions',
    selector: row => <ActionsCell data={row} />,
    width: '200px',
  },
];

export default eventDebuggerTableColumns;
